export default __webpack_public_path__ + "static/lefafa_1_5-941d813b842322d974263c1ba36cf0bb.webp";